import('./bootstrap').catch((error) => console.error('Application failed to load', error));
